// Pathify
import Vue from 'vue'
import { make } from 'vuex-pathify'
import axios from 'axios'
import router from '@/router'

Vue.use(router)

// Data
const state = {
  document_options: {},
  document_search: '',
  transaction_options: {},
  transaction_search: '',
  notification_options: {},
  notification_search: '',
  notifications: [],
}

const mutations = {
  ...make.mutations(state),
  SET_NOTIFICATIONS (context, payload) {
    console.log(payload)
    state.notifications.push(payload)
    // console.log(state.snackbars.filter(s => s.showing))
  },
}

const actions = {
  ...make.actions(state),
  fetch (context, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/profile').then(result => {
        resolve(result.data)
      }).catch(error => {
        if (error.response.status === 401) {
          mutations.logout()
        }
        reject(error)
      })
    })
  },
  update (context, payload) {
    return new Promise((resolve, reject) => {
      axios.patch('/api/profile', payload)
        .then(result => {
          state.user = result.data
          resolve(result.data)
        }).catch(error => {
        if (error.response.status === 422) {
          reject(error.response.data.errors)
        }
        reject(error)
      })
    })
  },
  fetchPilotInfo (context, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/profile/pilot-info').then(result => {
        resolve(result.data)
      }).catch(error => {
        if (error.response.status === 401) {
          mutations.logout()
        }
        reject(error)
      })
    })
  },
  updatePilotInfo (context, payload) {
    return new Promise((resolve, reject) => {
      axios.patch('/api/profile/pilot-info', payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        if (error.response.status === 422) {
          reject(error.response.data.errors)
        }
        reject(error)
      })
    })
  },
  search_transactions (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/profile/search-transactions', payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        reject(error)
      })
    })
  },
  search_documents (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/profile/search-documents', payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        reject(error)
      })
    })
  },
  updatePassword (context, payload) {
    return new Promise((resolve, reject) => {
      axios.patch('/api/profile/password', payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        if (error.response.status === 422) {
          reject(error.response.data.errors)
        }
        reject(error)
      })
    })
  },
  getNotifications (context, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/profile/notifications', payload)
        .then(result => {
          state.notifications = result.data.map(function (m) {
            return { id: m.id, message: m.message }
          })
          // console.log(state.notifications)
          // resolve(result.data)
        }).catch(error => {
        if (error.response.status === 422) {
          reject(error.response.data.errors)
        }
        reject(error)
      })
    })
  },
  getOrganization (context, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/profile/organization', payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        if (error.response.status === 422) {
          reject(error.response.data.errors)
        }
        reject(error)
      })
    })
  },
  updateOrganization (context, payload) {
    return new Promise((resolve, reject) => {
      axios.patch('/api/profile/organization', payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        if (error.response.status === 422) {
          reject(error.response.data.errors)
        }
        reject(error)
      })
    })
  },
  searchNotifications (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/profile/search-notifications', payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        if (error.response.status === 422) {
          reject(error.response.data.errors)
        }
        reject(error)
      })
    })
  },
  setNotificationRead (context, payload) {
    return new Promise((resolve, reject) => {
      axios.patch('/api/profile/set-notification-read', payload)
        .then(result => {
          state.notifications.splice(
            state.notifications.indexOf(
              state.notifications.filter(n => n.id === payload.id))
            , 1)
          resolve(result.data)
        }).catch(error => {
        if (error.response.status === 422) {
          reject(error.response.data.errors)
        }
        reject(error)
      })
    })
  },
  deleteNotification (context, payload) {
    return new Promise((resolve, reject) => {
      // console.log(payload)
      axios.delete('/api/profile/notification/' + payload.id)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        if (error.response.status === 422) {
          reject(error.response.data.errors)
        }
        reject(error)
      })
    })
  },
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
